import { z } from 'zod'
import { matchIsValidTel } from 'mui-tel-input'
import isEmail from 'validator/lib/isEmail'
import isMobilePhone from 'validator/lib/isMobilePhone'

const UK_POSTCODE_REGEX =
  /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/

export const requiredString = (label: string) =>
  z.string().min(1, `${label} is required.`)

const EMAIL_ERROR = 'Enter a valid email address'

export const emailField = requiredString('Email address').refine(
  value => isEmail(value),
  EMAIL_ERROR,
)

export const optionalEmailField = z
  .string()
  .refine(value => !value.trim() || isEmail(value), EMAIL_ERROR)

/**
 * Mirrors ePharmacy `PhoneValidator`: international (`+`) numbers are checked
 * with mui-tel-input, anything else with validator's mobile phone check.
 */
const isValidPhone = (value: string) => {
  if (value.startsWith('+')) {
    return matchIsValidTel(value)
  }
  return isMobilePhone(value.replace(/[^\d+]/g, ''), 'any')
}

const PHONE_ERROR = 'Please enter valid telephone number'

export const phoneField = z
  .string()
  .min(1, 'Phone number is required')
  .refine(isValidPhone, PHONE_ERROR)

export const optionalPhoneField = z
  .string()
  .refine(value => !value.trim() || isValidPhone(value), PHONE_ERROR)

const POSTCODE_ERROR = 'This is not a valid Postcode for the UK'

export const postcodeField = z
  .string()
  .min(1, 'Postcode is required')
  .regex(UK_POSTCODE_REGEX, POSTCODE_ERROR)

export const optionalPostcodeField = z
  .string()
  .refine(
    value => !value.trim() || UK_POSTCODE_REGEX.test(value),
    POSTCODE_ERROR,
  )
